export default __webpack_public_path__ + "static/media/IMG_2194.16c7a23e.jpg";